<template>
  <div>
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0">{{ this.$route.name }}</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item active"><i v-bind:class="routeIcon"></i> {{ $t(this.$route.name) }}</li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <section class="content">
      <div class="container-fluid">
        <div class="row col-lg-12">
          <div class="form-group col-sm-2">
            <EditForm :default-values="{}" create title="Create source proxy" @finish="handleItemsUpdate">
              <template #button="{ onclick }">
                <b-button type="button" variant="success" @click="onclick"><i class="fas fa-plus"></i> Create</b-button>
              </template>
            </EditForm>
          </div>
        </div>

        <b-row class="col-lg-12">
          <div class="col-lg-3 col-md-3 col-sm-12">
            <multiselect id="tables-input" v-model="filters.sourceId" :options="sourcesOptions"
              :custom-label="(opt) => this.$store.getters['sourcesModule/getName'](opt)" :multiple="false"
              :placeholder="$t('Select')" :select-label="$t('Press enter to select')" :selected-label="$t('Selected')"
              :loading="!this.$store.getters['sourcesModule/loaded']"
              :disabled="!this.$store.getters['sourcesModule/loaded']" />
          </div>
          <div class="col-lg-3 col-md-3 col-sm-12" v-for="({ id, label }) in filterInputs" v-bind:key="id">
            <b-form-group label-cols-lg="3" :label-for="id + '-filter-input'" :label="label">
              <b-form-input :id="id + '-filter-input'" v-model="filters[id]" autocomplete="off"
                :placeholder="'Enter ' + label" />
            </b-form-group>
          </div>
        </b-row>

        <b-row class="col-lg-12">
          <div class="col-lg-12 col-md-12 col-sm-12 apply-clear">
            <FilterButtons :cancel="this.cancel" :loadFn="loadItems" :cancelFn="cancelRequest"
              :resetFn="clearFilters" />
          </div>
        </b-row>

        <div class="row col-12" id="loading-container">
          <div class="col-12 mb-10">
            <div class="mb-10">
              <div class="scroll-wrapper">
                <div class="scroll">
                </div>
              </div>
              <div class="table-wrapper mb-10">
                <b-table :striped="true" :small="true" :hover="true" :empty-text="emptyText" show-empty
                  :sort-by="sortBy" :sort-desc="sortDesc" :busy="!!cancel" :items="items" :fields="fields"
                  :no-local-sorting="true" :sort-icon-left="true" @sort-changed="sortingChanged">
                  <template #cell(actions)="row">
                    <EditForm :default-values="row.item" title="Edit source proxy" @finish="handleItemsUpdate" />
                    <RemoveForm :object="row.item.id" message="Please confirm removing source proxy"
                      :url="'/api/v1/source-proxies/' + row.item.id" @finish="handleItemsUpdate" />
                  </template>
                </b-table>

              </div>
            </div>

            <div class="row mb-10">
              <div class="col-12">
                <b-pagination class="float-right" v-model="pagination.page" :total-rows="pagination.records"
                  :per-page="pagination.onPage" @change="onPageChange" first-number last-number />
              </div>
            </div>

            <div class="row mb-10">
              <div class="col-12">
                <ve-pagination class="float-right" :page-index="pagination.page" :page-size="pagination.onPage"
                  :total="pagination.records" :pagingCount="pagination.count" :layout="['total', 'sizer']"
                  :pageSizeOption="pagination.pageSizeOption" @on-page-size-change="onPageSizeChange" />
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import RemoveForm from "../../components/remove-form/RemoveForm.vue";
import axios from "axios";
import { getRouteIcon, ROUTE_SOURCES } from "../../utils/routerIcons";
import FilterButtons from "../../components/FilterButtons.vue";
import Multiselect from "vue-multiselect";
import EditForm from "../../components/SourceProxy/EditSourceProxyForm.vue";

function getDefaultPagination() {
  return {
    onPage: 25,
    page: 1,
    records: 0,
    count: 5,
    pageSizeOption: [25, 50, 100, 200],
  };
}

export default {
  components: {
    Multiselect,
    RemoveForm,
    FilterButtons,
    EditForm
  },
  data() {
    return {
      cancel: null,
      error: null,
      fields: [
        { key: 'id', label: 'ID' },
        { key: 'sourceName', label: 'Source Name' },
        { key: 'apiKey', label: 'API Key', },
        { key: 'slaveId', label: 'Slave ID', },
        { key: 'url', label: 'URL', },
        { key: 'actions', label: 'Actions', }
      ],
      items: [],
      sortBy: null,
      sortDesc: null,
      filters: {},
      pagination: getDefaultPagination(),
      filterInputs: [
        { label: 'API key', id: 'apiKey' },
        { label: 'Slave ID', id: 'slaveId' },
      ],
    }
  },
  computed: {
    sourcesOptions() {
      return this.$store.getters['sourcesModule/list'].map((source) => source.id)
    },
    emptyText() {
      if (this.cancel) {
        return 'Loading items..';
      }

      if (this.error) {
        return this.error;
      }

      return 'There are no records to show';
    },
    routeIcon: () => getRouteIcon(ROUTE_SOURCES),
  },
  methods: {
    sortingChanged(ctx) {
      this.sortBy = ctx.sortBy;
      this.sortDesc = ctx.sortDesc;
      this.pagination.page = 1;

      this.loadItems();
    },
    handleItemsUpdate() {
      this.loadItems();
    },
    clearFilters() {
      this.filters = {};
      this.sortingChanged({
        sortBy: null,
        sortDesc: null
      })
    },
    loadItems() {
      this.error = null;
      let loadingInstance = this.$veLoading({
        target: document.querySelector("#loading-container"),
        name: "wave",
      });

      this.items = [];

      let self = this;
      loadingInstance.show();

      this
        .$http({
          url: '/api/v1/source-proxies',
          params: {
            ...this.filters,
            // pagination
            limit: this.pagination.onPage,
            offset: this.pagination.onPage * (this.pagination.page - 1),

            // sort params
            orderBy: this.sortBy,
            direction: this.sortDesc ? 'DESC' : 'ASC',
          },
          method: 'GET',
          cancelToken: new axios.CancelToken(c => { self.cancel = c })
        })
        .then(resp => {
          let { items, pagination: { limit, totalCount } } = resp.data;

          this.items = items;
          this.pagination.onPage = limit;
          this.pagination.records = totalCount;
        })
        .catch((err) => {
          this.items = [];
          this.error = err;
        })
        .finally(() => {
          loadingInstance.close();
          this.cancel = null;
        });
    },
    cancelRequest() {
      if (this.cancel) {
        this.cancel('this -> cancel previous request');
      }
    },
    onPageChange(page) {
      this.pagination.page = page;
      this.loadItems()
    },
    onPageSizeChange(pageSize) {
      this.pagination.page = 1;
      this.pagination.onPage = pageSize;
      this.loadItems();
    },
    onFinishEdit() {
      this.loadItems();
    },
  },
  mounted() {
    this.loadItems();
    this.$store.dispatch('sourcesModule/loadList')
  }
}
</script>
